import React from 'react'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import {SideNavItem} from './SideNav.styled'

import {Icon} from '~/components/general/icon/Icon'
import {theme} from '~/styles/theme'

export type PractitionerNavSectionProps = {
  isActive: {
    patients: boolean
    materials: boolean
    questionnaires: boolean
    screening: boolean
    reports: boolean
  }
  showAppointments: boolean
  showReports: boolean
}

export const PractitionerNavSection: React.FC<PractitionerNavSectionProps> = ({
  isActive,
  showAppointments,
  showReports,
}) => {
  const {t} = useTranslation<string>()

  return (
    <>
      <Link to="/app/patients" data-tip={t('My patients')} data-for="sideNav">
        <SideNavItem active={isActive.patients}>
          <Icon
            name="Patients"
            color={isActive.patients ? undefined : theme.colors.grey.main}
          />
        </SideNavItem>
      </Link>
      <Link
        to="/app/materials"
        data-tip={t('Educational materials')}
        data-for="sideNav">
        <SideNavItem active={isActive.materials}>
          <Icon
            name="BookOpen"
            color={isActive.materials ? undefined : theme.colors.grey.main}
          />
        </SideNavItem>
      </Link>
      <Link
        to="/app/questionnaires"
        data-tip={t('Questionnaires')}
        data-for="sideNav">
        <SideNavItem active={isActive.questionnaires}>
          <Icon
            name="Questionnaires"
            color={isActive.questionnaires ? undefined : theme.colors.grey.main}
          />
        </SideNavItem>
      </Link>
      {showAppointments && (
        <Link
          to="/app/appointments"
          data-tip={t('My Appointments')}
          data-for="sideNav">
          <SideNavItem active={isActive.screening}>
            <Icon
              name="Calendar"
              color={isActive.screening ? undefined : theme.colors.grey.main}
            />
          </SideNavItem>
        </Link>
      )}
      {showReports && (
        <Link
          to="/app/reports/patients"
          data-tip={t('Reports')}
          data-for="sideNav">
          <SideNavItem active={isActive.reports}>
            <Icon
              name="Reports"
              color={isActive.reports ? undefined : theme.colors.grey.main}
            />
          </SideNavItem>
        </Link>
      )}
    </>
  )
}
